import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class PaymentsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{PaymentsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <span>payments go here ...</span>
                    </div>
                </div>
            </div>
        );
    }
}

PaymentsPage.meta = {
    label: <FormattedMessage id={'payments'} defaultMessage={'Payments'} />,
    icon: 'local_atm',
    action: () => history.push('/payments'),
    locations: ['/payments']
};

export default PaymentsPage;



// WEBPACK FOOTER //
// ./src/pages/payments/index.jsx